import { toast } from "react-toastify";
import { Post } from "../../AxiosCRUDFunctions";
import { apiHeader, BaseURL } from "../../config";
import { getToken } from "../../helpers/tokenStorage";
// src/api/medicineAPI.js
//get all medicine handler
export const fetchDoctorList = async ({
  pageNumber = 1,
  limit = 10,
  sortField = "",
  sortDirection = "desc",
  doctorId = 0,
  locationId = 0,
  medicinePharmaLinkId = 0,
  filters = {},
}) => {
  const response = await Post(
    BaseURL("doctor/get-doctor-list"),
    {
      pageNumber,
      pageSize: 10,
      totalRowsCount: 0,
      sortField,
      sortDirection,
      search: filters?.search || "",
      filter: {
        locationId: filters?.locationId || locationId,
        medicinePharmaLinkId,
        doctorId,
        fromDate: filters?.fromDate || "",
        toDate: filters?.toDate || "",
        targetStatus: filters?.targetStatus || "",
        targetFilter: {
          minValue: filters?.targetFilter?.minValue || 0,
          maxValue: filters?.targetFilter?.maxValue || 0
        },
        estimatedFilter: {
          minValue: filters?.estimatedFilter?.minValue || 0,
          maxValue: filters?.estimatedFilter?.maxValue || 0
        }
      },
    },
    apiHeader(getToken())
  );
  if (response?.data?.headers?.error === 200) {
    return response?.data?.body;
  } else {
    toast.error(response?.data?.headers?.error);
    return [];
  }
};
//add doctor handler
export const addDoctorToAPI = async (params) => {
  const response = await Post(
    BaseURL("doctor/add-doctor"),
    params,
    apiHeader(getToken())
  );
  if (response?.data?.headers?.error == 200) {
    toast.success("Doctor Created Successfully");
  } else {
    toast.error(response?.data?.headers?.message);
  }
};
//update doctor
export const updateDoctorInAPI = async (params) => {
  const response = await Post(
    BaseURL("doctor/update-doctor"),
    params,
    apiHeader(getToken())
  );
  if (response?.data?.headers?.error == 200) {
    toast.success("Doctor Updated Successfully");
  } else {
    toast.error(response?.data?.headers?.message);
  }
  // return response.data;
};
//delete medicine
export const deleteDoctorFromAPI = async (params) => {
  const response = await Post(
    BaseURL("doctor/delete-doctor"),
    params,
    apiHeader(getToken())
  );

  if (response?.data?.headers?.error == 200) {
    toast.success("Doctor Deleted Successfully");
  } else {
    toast.error(response?.data?.headers?.message);
  }
};
//get Doctor By Id
export const getDoctorByIdAPI = async (params) => {
  const response = await Post(
    BaseURL("doctor/get-doctor-ById"),
    params,
    apiHeader(getToken())
  );
  if (response?.data?.headers?.error === 200) return response?.data?.body;
  toast.error(response?.data?.headers?.message);
  return null;
};

export const activeOrInactiveInAPI = async (params) => {
  const response = await Post(
    BaseURL("doctor/activeinactive-doctor"),
    params,
    apiHeader(getToken())
  );

  if (response?.data?.headers?.error == 200) {
    toast.success("status updated successfully");
  } else {
    toast.error(response?.data?.headers?.message);
  }
};
//link doctor to medicine
export const linkDoctorToMedicineInAPI = async (params) => {
  const response = await Post(
    BaseURL("doctor/link-medicine-target"),
    params,
    apiHeader(getToken())
  );
  if (response?.data?.headers?.error === 200) {
    toast.success("Doctor Link to Medicine Link Successfully");
    return true;
  } else {
    toast.error(response?.data?.headers?.message);
  }
};

export const modifyTargetInAPI = async (params) => {
  const response = await Post(
    BaseURL("doctor/modify-target"),
    params,
    apiHeader(getToken())
  );
  if (response?.data?.headers?.error === 200) {
    toast.success("Target Modified Successfully");
  } else {
    toast.error(response?.data?.headers?.message);
  }
};

export const getAllDoctorDashboard = async () => {
  const response = await Post(
    BaseURL("doctor/get-doctor-dashboard"),
    {},
    apiHeader(getToken())
  );
  if (response?.data?.headers?.error === 200) return response?.data?.body;
  toast.error(response?.data?.headers?.message);
  return null;
};

export const getDoctorStatisticsApi = async (data) => {
  const response = await Post(
    BaseURL("doctor/get-doctor-statistic"),
    data,
    apiHeader(getToken())
  );
  if (response?.data?.headers?.error === 200) return response?.data?.body;
  toast.error(response?.data?.headers?.message);
  return null;
};
